import React, { FC } from "react";

import { Loading } from "ui-library/atoms";

import { Form } from "core/hookForm";
import { FormState } from "types";

import { CampaignForm, ErrorContent } from "./containers";
import { useElCommunicationCampaignForm } from "./hooks/useElCommunicationCampaignForm";

export const ElCommunicationCampaignForm: FC = () => {
    const { form, formState, isProcessing, onSubmit, campaignData } = useElCommunicationCampaignForm();

    return (
        <Form form={form} onSubmit={() => {}}>
            <Loading fullPage loading={isProcessing} />
            {formState === FormState.EDIT && <CampaignForm campaignData={campaignData} isProcessing={isProcessing} onSubmit={onSubmit} />}
            {formState === FormState.ERROR && <ErrorContent />}
        </Form>
    );
};
